// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar-FdBM8","sidebarOverlay":"sidebarOverlay-GcSmE"};